// extracted by mini-css-extract-plugin
export var growableInput = "_5f-0";
export var tagContainer = "_5f-2";
export var textInput = "_5f-1";